import { ReactNode } from 'react';

import { ScrollView } from '@rbilabs/universal-components';

import { KeyboardAwareView } from 'components/ucl/keyboard-aware-view';

import { ActionsheetContentStyled } from './styled';

export const ModalAuthActionSheetContent: React.FC<{
  children: ReactNode;
  isKeyboardAwareDisabled?: boolean;
}> = ({ children }) => (
  <ActionsheetContentStyled>
    <ScrollView>
      <KeyboardAwareView withScroll>{children}</KeyboardAwareView>
    </ScrollView>
  </ActionsheetContentStyled>
);
